export const generateUniqueID = () => {
  const firstPart = parseInt(Math.random() * 46656)
  const secondPart = parseInt(Math.random() * 46656)

  const slicedFirstPart = ('000' + firstPart.toString(36)).slice(-3)
  const slicedSecondPart = ('000' + secondPart.toString(36)).slice(-4)

  return slicedFirstPart + slicedSecondPart
}
